import { useState } from "react";

import BriefEditor from "../../brief/BriefEditor";
import type { Brief } from "../../brief/schema";
import { PromiseToast } from "../../components/async/PromiseToast";
import Button from "../../components/Button/Button";
import OnlyWithPermission from "../../components/OnlyWithPermission";
import LightPageLayout from "../../components/Page/LightPageLayout";
import PageHeader from "../../components/Page/PageHeader";
import {
    callOutgoingRequest,
    refreshOutgoingRequest,
    useOutgoingRequest,
} from "../../data/tanstack-query";
import { getBrief, updateBrief } from "../../endpoints/outgoing-requests";
import { Permission } from "../../enums/Permission";
import useSubmit from "../../hooks/useSubmit";
import { usePathParams } from "../../navigation/hooks";
import { goBack } from "../../navigation/location";
import { briefEditorRoute } from "./navigation";

export default function BriefEditorPage() {
    const { id } = usePathParams(briefEditorRoute);
    const brief = useOutgoingRequest(getBrief(id));
    const [draft, setDraft] = useState<Brief>({ blocks: brief.blocks });

    const [onSave, saving] = useSubmit(async () => {
        await callOutgoingRequest(updateBrief(id, { ...brief, blocks: draft.blocks }));
        await refreshOutgoingRequest(getBrief(id));
        goBack();
    }, [brief, draft, id]);

    return (
        <LightPageLayout>
            <PromiseToast promise={saving} message="Brief enregistré" />
            <PageHeader
                title="Éditer le brief"
                action={
                    <OnlyWithPermission permission={Permission.Editorial}>
                        <Button label="Enregistrer" action={onSave} feeling="minor" role="minor" />
                    </OnlyWithPermission>
                }
            />
            <BriefEditor value={draft} onChange={setDraft} />
        </LightPageLayout>
    );
}
